var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.amount !== null)?_c('div',{staticClass:"whitespace-nowrap",class:{'text-red-500': _vm.isNegative}},[(_vm.isEUR)?_c('span',[_vm._v(_vm._s(_vm._f("centsToEuroString")(_vm.amount)))]):(_vm.isUSD)?_c('span',[_vm._v(_vm._s(_vm._f("centsToDollarString")(_vm.amount)))]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }